export default __webpack_public_path__ + "static/media/CrossloadLogo_Icon.e89355f3.png";